/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */



import {NgModule} from '@angular/core';
import {ClrDatagridModule} from './datagrid/datagrid.module';
import {ClrStackViewModule} from './stack-view/stack-view.module';
import {ClrTreeViewModule} from './tree-view/tree-view.module';
export class ClrDataModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{exports: [ClrDatagridModule, ClrStackViewModule, ClrTreeViewModule]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrDataModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrDataModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrDataModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
